<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="align-end justify-end">
        <v-flex xs12 md6 sm8 class="pa-1">
          <v-card>
            <v-card-text class="client-details">
              <client-details :client="client" :errors="errors" :canDelete="canDelete"></client-details>
            </v-card-text>
            <v-card-actions>
              <confirm-password @confirmed="goTo('/adverse_reactions/create?client_id=' + client.id)">
                <v-btn small color="error" title="Report Adverse Reaction / Event">Adverse Reaction / Event</v-btn>
              </confirm-password>
              <v-spacer></v-spacer>
              <v-btn small color="orange" @click="goTo('/clients/' + client.id + '/edit')" v-show="canEdit" icon title="Edit">
                <v-icon>{{ icons.edit }}</v-icon>
              </v-btn>
              <delete-client v-show="canDelete" :client="client"></delete-client>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 class="pa-1">
          <v-card>
            <v-card-title class="py-0">
              Recent Visits
              <v-spacer></v-spacer>
              <v-btn small text @click="addVisit = !addVisit" outlined>Add</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="visits" :headers="headers" dense :items-per-page="5" :sort-by="['date']" :sort-desc="[true]" multi-sort>
                <template v-slot:item="{ item }">
                  <tr @click="goTo('/clients/' + client.id + '/visits/' + item.id)">
                    <td>{{ item.date }}</td>
                    <td>{{ item.user.name }}</td>
                    <td>
                      <inertia-link :href="'/clients/' + client.id + '/visits/' + item.id">View</inertia-link>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 class="pa-1">
          <v-card>
            <v-card-title class="py-0">
              <v-spacer></v-spacer>Service Requests
            </v-card-title>
            <v-card-text>
              <service-requests-table :client="client" :service_requests="service_requests"></service-requests-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addVisit" @close="addVisit = false">
        <template slot="title">Add New Visit</template>
        <v-card flat>
          <v-card-text>
            <form @submit.prevent="saveVisit(visit)">
              <!-- <v-text-field label="Date of Visit" v-model="visit.date" required="required" ref="datepicker" type="date"></v-text-field> -->
              <date-picker v-model="visit.date" required="required" ref="picker" class=""></date-picker>
              <v-btn type="submit" small color="primary" class="pull-right" :disabled="!visit.date" :loading="creatingVisit">Save</v-btn><br>
            </form>
          </v-card-text>
        </v-card>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import Layout from '@/Layouts/MainLayout.vue'
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')
  const ServiceRequestsTable =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/index')
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details')
  const DatePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/datepicker')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')
  const ClientDetails = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "clients" */ '@/Components/Clients/show')
  const DeleteClient = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "clients" */ '@/Components/Clients/components/deleteClient')

  export default {
    name: 'ShowClient',
    metaInfo () {
      return {
        title: 'View Patient - ' + this.client.name,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    components: {
      MyDetails,
      DatePicker,
      DeleteClient,
      ClientDetails,
      ConfirmPassword,
      ModalDialog,
      ServiceRequestsTable
    },
    props: [
      'client', 'canEdit', 'canDelete', 'errors'
    ],
    layout: Layout,
    data () {
      return {
        addVisit: false,
        visit: {
          // date: (new Date).toLocaleDateString()
          date: this.moment().format('yyyy-MM-DD')
        },
        headers: [
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'User/Professional', value: 'user_name'
          },
          {
            text: '', value: 'link', sortable: false
          }
        ],
        creatingVisit: false,
      }
    },
    methods: {
      submit () {
        if (confirm('Are you sure you want to update patient details?')) {
          this.$inertia.put('/clients/' + this.client.id, this.client)
        }
      },
      deleteClient (client) {
        if (confirm('Are you sure you want to delete this patient\'s details?')) {
          this.$inertia.delete('/clients/' + client.id)
        }
      },
      saveVisit (visit) {
        this.$inertia.post('/clients/' + this.client.id + '/visits', visit, {
          onSuccess: () => {
            return Promise.all([
              // this.$inertia.visit('/clients/' + this.client.id, { only: ['visits', 'client']})
            ])
           },
           onBefore: () => this.creatingVisit = true,
           onFinish: () => this.creatingVisit = false,
        })
      }
    },
    mounted () {
      this.$inertia.reload({ only: ['client']})
    },
    computed: {
      visits () {
        return this.client.visits
      },
      service_requests () {
        return this.client.service_requests
      }
    },
    watch: {
      //
    }
  }
</script>

<style scoped>
  .client-details > p {
    margin-top: 0px;
    margin-bottom: 1px;
  }
</style>
